import ValidationRule from './validation.rule.js';

export default class NotBlankRule extends ValidationRule {
    constructor(manager, settings = {}) {
        super(manager, settings);

        this.element = document.getElementById(settings.element);


        this.element.addEventListener('input', () => {
            this.resetValidity(this.email);
        });

        this.element.addEventListener('blur', event => {
            this.element.value = this.element.value?.trim();
        });
    }

    getRuleName() {
        return 'not-blank';
    }

    resetValidity(elt) {}

    refreshValidity(target) {

    }

    invalidate() {

    }

    clearValidity() {
            this.resetValidity(this.element);

    }
    refreshFeedback() {
        this.refreshValidity();
    }


    async check () {
        return this.element.value?.trim().length > 0 ;
    }
}
